import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { GuidanceProvider } from "./contexts/GuidanceContext";
import { OrganisationProvider } from "./contexts/OrganisationContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { Dashboard } from "./pages/Dashboard";
import { Standards } from "./pages/Standards";
import { StandardClauses } from "./pages/StandardClauses";
import { Clause } from "./pages/Clause";
import { Vault } from "./pages/Vault";
import { EvidenceNew } from "./pages/EvidenceNew";
import { EvidenceDetail } from "./pages/EvidenceDetail";
import { AuditLog } from "./pages/AuditLog";
import { Nonconformities } from "./pages/Nonconformities";
import { NonconformityNew } from "./pages/NonconformityNew";
import { NonconformityDetail } from "./pages/NonconformityDetail";
import { Members } from "./pages/Members";
import { Network } from "./pages/Network";
import { Parties } from "./pages/Parties";
import { PartyDetail } from "./pages/PartyDetail";
import { PartyNew } from "./pages/PartyNew";
import { SupplierEvidence } from "./pages/SupplierEvidence";
import { Billing } from "./pages/Billing";
import { BillingUpgrade } from "./pages/BillingUpgrade";
import { Settings } from "./pages/Settings";
import { SettingsBillingTier } from "./pages/SettingsBillingTier";
import { SettingsBranding } from "./pages/SettingsBranding";
import { SettingsProfile } from "./pages/SettingsProfile";
import { SwitchOrg } from "./pages/SwitchOrg";
import { ProtectedLayout } from "./components/layout/ProtectedLayout";

export function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <OrganisationProvider>
          <GuidanceProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/switch" element={<SwitchOrg />} />
                <Route element={<ProtectedLayout />}>
                  <Route path="/o/:slug/dashboard" element={<Dashboard />} />
                  <Route path="/o/:slug/standards" element={<Standards />} />
                  <Route path="/o/:slug/standards/:code/:year" element={<StandardClauses />} />
                  <Route path="/o/:slug/standards/:code/:year/:ref" element={<Clause />} />
                  <Route path="/o/:slug/vault" element={<Vault />} />
                  <Route path="/o/:slug/vault/new" element={<EvidenceNew />} />
                  <Route path="/o/:slug/vault/:uuid" element={<EvidenceDetail />} />
                  <Route path="/o/:slug/audit-log" element={<AuditLog />} />
                  <Route path="/o/:slug/nonconformities" element={<Nonconformities />} />
                  <Route path="/o/:slug/nonconformities/new" element={<NonconformityNew />} />
                  <Route path="/o/:slug/nonconformities/:uuid" element={<NonconformityDetail />} />
                  <Route path="/o/:slug/settings" element={<Settings />} />
                  <Route path="/o/:slug/settings/branding" element={<SettingsBranding />} />
                  <Route path="/o/:slug/settings/profile" element={<SettingsProfile />} />
                  <Route path="/o/:slug/settings/members" element={<Members />} />
                  <Route path="/o/:slug/network" element={<Network />} />
                  <Route path="/o/:slug/network/supplier-evidence" element={<SupplierEvidence />} />
                  <Route path="/o/:slug/parties" element={<Parties />} />
                  <Route path="/o/:slug/parties/new" element={<PartyNew />} />
                  <Route path="/o/:slug/parties/:uuid" element={<PartyDetail />} />
                  <Route path="/o/:slug/billing" element={<Billing />} />
                  <Route path="/o/:slug/billing/upgrade" element={<BillingUpgrade />} />
                  <Route path="/o/:slug/settings/billing-tier" element={<SettingsBillingTier />} />
                </Route>
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </BrowserRouter>
          </GuidanceProvider>
        </OrganisationProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
